/* funcion para formatear nombres minusculas todas y primera mays
utilizado en Dog-criador, Dog-copropietario
 */
export function formatearNombres(texto) {
    const tmp = texto.trim().split(" ");
    let salida = "";
    tmp.forEach(e => {
        salida += e[0].toUpperCase() + e.toLowerCase().slice(1) + " ";
    });
    return salida.trim();
}